import React from 'react';
import DriveFileRenameOutlineIcon from '@mui/icons-material/DriveFileRenameOutline';
import material from '../assets/material.jpg'

import mailingCreate from '../assets/mailingCreate.webp'

import productMain from '../assets/productMain.jpg'
import ourPartners from '../assets/ourPartners.png'
import applicationPage from '../assets/applicationPage.png'
import applicationCallMePage from '../assets/applicationCallMePage.png'
import allPartnerApplications from '../assets/allPartnerApplications.jpg'
import featuredProduct from '../assets/featuredProduct.jpg'
import applicationChangeProfile from '../assets/23-2.jpg'
import profileMetal from '../assets/ProfileMetal.webp'
import lightImg from '../assets/LightImg.jpg'
import PersonOutlineIcon from '@mui/icons-material/PersonOutline';
import BorderColorIcon from '@mui/icons-material/BorderColor';
import CategoryIcon from '@mui/icons-material/Category';
import SettingsIcon from '@mui/icons-material/Settings';
import ImageIcon from '@mui/icons-material/Image';
import FilterFramesIcon from '@mui/icons-material/FilterFrames';
import CurtainsClosedIcon from '@mui/icons-material/CurtainsClosed';
import AssessmentIcon from '@mui/icons-material/Assessment';
import HandshakeIcon from '@mui/icons-material/Handshake';
import CollectionsIcon from '@mui/icons-material/Collections';
import DraftsIcon from '@mui/icons-material/Drafts';
import ChatIcon from '@mui/icons-material/Chat';
import AccountBalanceWalletIcon from '@mui/icons-material/AccountBalanceWallet';
import AssignmentTurnedInIcon from '@mui/icons-material/AssignmentTurnedIn';

export const roleOptions = [
    { value: 'user', name: 'User' },
    { value: 'partner', name: 'Partner' },
    { value: 'storeOwner', name: 'Store Owner' },
    { value: 'officeWorker', name: 'Office Worker' },
    { value: 'cityAdmin', name: 'City Admin' },
    { value: 'admin', name: 'Admin' },
    { value: 'superAdmin', name: 'Super Admin' },
];
export const firstNames = ['Алексей', 'Иван', 'Дмитрий', 'Сергей', 'Егор', 'Михаил', 'Павел', 'Андрей', 'Никита', 'Кирилл'];
export const lastNames = ['Иванов', 'Петров', 'Сидоров', 'Смирнов', 'Кузнецов', 'Попов', 'Соколов', 'Лебедев', 'Новиков', 'Морозов'];
export const orgNames = ['ООО "Альфа"', 'ООО "Бета"', 'ООО "Гамма"', 'ИП Виктор', 'ООО "Вектор"', 'ООО "Норд"'];


export const selectItemSearchProduct = [
    { value: 'productsFullName', text: 'Полное имя(СДМ 0001)' },
    { value: 'productsD', text: 'По подробному описанию' },
    { value: 'productsCatN', text: 'Имя категории' },
    { value: 'categoryNamePlusMaterialText', text: 'По категории + материал(бетон)' },
    { value: 'allParameters', text: 'По всем параметрам сразу' },
]

export const mainItemsHref = [
    {
        href: "/containerProductPage",
        text: "Продукты",
        icon: <CurtainsClosedIcon />
    },
    {
        href: "/admin/catalog-review",
        text: "Каталог форм · ADMIN",
        icon: <AssessmentIcon />
    },
    {
        href: "/category",
        text: "Категории",
        icon: <CategoryIcon />
    },
    {
        href: "/workLog",
        text: "Тайминг",
        icon: <CategoryIcon />
    },
    {
        href: "/calls",
        text: "звонки.v2",
        icon: <ChatIcon />
    },
    // {
    //     href: "/calls-Directory",
    //     text: "звонки",
    //     icon: <ChatIcon />
    // },
    {
        href: "/admin/estimates",
        text: "Сметы",
        icon: <ChatIcon />
    },
    {
        href: "/admin/offers",
        text: "КП",
        icon: <ChatIcon />
    },
    {
        href: "/chat",
        text: "Чаты",
        icon: <ChatIcon />
    },
    {
        // Задачи: списки, сроки, календарь — те же, что в приложении.
        href: "/admin/todo",
        text: "Задачи",
        icon: <AssignmentTurnedInIcon />
    },
    {
        href: "/officeOwner-setting",
        text: "Начальство магазинов",
        icon: <DraftsIcon />
    },
    {
        href: "/office-setting",
        text: "Офисы-Магазины",
        icon: <DraftsIcon />
    },
    {
        href: "/mailing",
        text: "Рассылка",
        icon: <DraftsIcon />
    },

    {
        href: "/blog",
        text: "Блог",
        icon: <CategoryIcon />
    },
    {
        href: "/orders",
        text: "Заказы",
        icon: <FilterFramesIcon />
    },
    {
        href: "/portfolio",
        text: "Портфолио",
        icon: <ImageIcon />
    },
    // {
    //   href: "/page",
    //   text: "Страницы",
    //   icon: <DocumentScannerIcon />
    // },
    {
        href: "/applicationPage",
        text: "Заявки",
        icon: <BorderColorIcon />
    },
    {
        href: "/galleryPhotoPage",
        text: "Галлерея",
        icon: <CollectionsIcon />
    },
    {
        href: "/analytics",
        text: "Аналитика",
        icon: <AssessmentIcon />
    },
    {
        href: "/containerPartnerPage",
        text: "Партнеры",
        icon: <HandshakeIcon />
    },
    {
        href: "/users",
        text: "Пользователи",
        icon: <PersonOutlineIcon />
    },
    {
        // Один вход в раздел: «Деньги», «Платежи» и «Биллинг» переключаются внутри.
        href: "/admin/money",
        text: "Финансы",
        icon: <AccountBalanceWalletIcon />
    },
    {
        href: "/siteSetting",
        text: "Настройки сайта",
        icon: <SettingsIcon />
    },
]

export const materialArray = [
    {
        text: "Материалы",
        href: "/materials",
        photo: ourPartners
    },
    {
        text: "Расходные материалы",
        href: "/productionMaterial",
        photo: profileMetal
    },
]

export const partnerArray = [
    {
        text: "Наши партнеры",
        href: "/partner/all",
        photo: ourPartners
    },
    {
        text: "Все заявки",
        href: "/partner/application",
        photo: allPartnerApplications
    },
]
export const mailingArray = [
    {
        text: "Создать рассылку",
        href: "/mailing/create",
        photo: mailingCreate
    },
    {
        text: "Список отправленных",
        href: "/mailing/lists",
        photo: featuredProduct
    },
]

const priceTagsImage = `data:image/svg+xml;utf8,${encodeURIComponent(`
<svg xmlns="http://www.w3.org/2000/svg" width="500" height="310" viewBox="0 0 500 310">
  <defs>
    <linearGradient id="g" x1="0" x2="1" y1="0" y2="1">
      <stop offset="0" stop-color="#2f3545"/>
      <stop offset="1" stop-color="#151926"/>
    </linearGradient>
  </defs>
  <rect width="500" height="310" rx="28" fill="url(#g)"/>
  <rect x="42" y="42" width="416" height="226" rx="22" fill="#202637" stroke="#6f7cff" stroke-width="4"/>
  <text x="250" y="132" text-anchor="middle" fill="#ffffff" font-family="Arial, sans-serif" font-size="46" font-weight="700">₽ + #</text>
  <text x="250" y="188" text-anchor="middle" fill="#b9c0d8" font-family="Arial, sans-serif" font-size="28" font-weight="600">Цена + теги</text>
</svg>
`)}`;

const catalogReviewImage = `data:image/svg+xml;utf8,${encodeURIComponent(`
<svg xmlns="http://www.w3.org/2000/svg" width="500" height="310" viewBox="0 0 500 310">
  <defs>
    <linearGradient id="catalogReviewGradient" x1="0" x2="1" y1="0" y2="1">
      <stop offset="0" stop-color="#111827"/>
      <stop offset="1" stop-color="#312e81"/>
    </linearGradient>
  </defs>
  <rect width="500" height="310" rx="28" fill="url(#catalogReviewGradient)"/>
  <rect x="38" y="38" width="424" height="234" rx="24" fill="#0f172a" stroke="#818cf8" stroke-width="4"/>
  <path d="M95 220V100c0-17 13-30 30-30h75c20 0 33 14 33 33v117z" fill="#1f2937" stroke="#c7d2fe" stroke-width="5"/>
  <path d="M270 220V126c0-16 13-29 29-29h79c16 0 29 13 29 29v94z" fill="#1f2937" stroke="#a7f3d0" stroke-width="5"/>
  <path d="M120 142c27-30 52-23 83-2" fill="none" stroke="#fbbf24" stroke-width="8" stroke-linecap="round"/>
  <path d="M300 151c24-30 48-27 75-5" fill="none" stroke="#fbbf24" stroke-width="8" stroke-linecap="round"/>
  <text x="250" y="258" text-anchor="middle" fill="#ffffff" font-family="Arial, sans-serif" font-size="27" font-weight="700">Формы · цены · ADMIN</text>
</svg>
`)}`;

export const prodArray = [
    {
        text: "Основная продукция",
        href: "/products/all",
        photo: productMain
    },
    {
        text: "Внешняя продукция",
        href: "/products/externalProducts",
        photo: productMain
    },
    {
        text: "Продукты по спискам",
        href: "/featuresProductItem",
        photo: featuredProduct
    },
    {
        text: "Цена + теги",
        href: "/containerProductPage/product-seo-price",
        photo: priceTagsImage
    },
    {
        text: "Каталог форм · ADMIN",
        href: "/admin/catalog-review",
        photo: catalogReviewImage
    },
    {
        text: "Материалы",
        href: "/containerMaterialPage",
        photo: material
    },
    {
        text: "Цвета(производство)",
        href: "/colorsProduct",
        photo: "https://www.teks.ru/files/treecontent/nodes/attaches/100/179/1_1.jpg"
    },
];
export const applicationArray = [
    {
        text: "Заявки (С временем)",
        href: "/applicationsCallMe",
        photo: applicationPage
    },
    {
        text: "Заявки (Задать Вопрос)",
        href: "/applications",
        photo: applicationCallMePage
    },
    {
        text: "Заявки (Изменить данные)",
        href: "/applicationsChangeProfile",
        photo: applicationChangeProfile
    },
    {
        text: "Заявки (Галерея)",
        href: "/applicationsGallery",
        photo: lightImg
    },
]

export const itemsLink = [
    {
        href: "/siteCategory",
        text: "Категории в сайтах"
    },
    {
        href: "/productListLink",
        text: "Списки продуктов на старницах"
    },
    {
        href: "/mainPageSetting",
        text: "Главные страницы"
    },
    {
        href: "/elementPaymentPageSetting",
        text: "Страница способов оплаты"
    },
    {
        href: "/regionSetting",
        text: "Все регионы"
    },
    {
        href: "/mainImageSetting",
        text: "Изображение главной страницы"
    },
    {
        href: "/pickupPointsSetting",
        text: "Точки самовывоза"
    },
    {
        href: "/warranty",
        text: "Гарантии"
    },
    {
        href: "/deliveryInfo",
        text: "Инфо доставка"
    },
    {
        href: "/paymentList",
        text: "Способы Оплаты"
    },
    {
        href: "/aboutUsSetting",
        text: "О нас"
    },
    {
        href: "/benefitsSetting",
        text: "Преймущества нашей компании"
    },
    {
        href: "/contactsSetting",
        text: "Контакты"
    },
    {
        href: "/contactsMSetting",
        text: "Наши соцсети"
    },
    {
        href: "/architectSetting",
        text: "Страница артитекторам"
    },
    {
        href: "/architectLiSetting",
        text: "Список на странице архитектор"
    },
    {
        href: "/architectSkillsSetting",
        text: "Список преимуществ на странице архитектор"
    },
]

export const modalLinkItem = [
    {
        icon: <DriveFileRenameOutlineIcon />,
        text: "партнерка",
    },
    {
        icon: <DriveFileRenameOutlineIcon />,
        text: "изменить номер"
    },
    {
        icon: <DriveFileRenameOutlineIcon />,
        text: "изменить email"
    },
    {
        icon: <DriveFileRenameOutlineIcon />,
        text: "Позвонить мне"
    },

]
